import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
    actions: {
        async getGuardrailTypesData(context) {
            const response = await Vue.axios.get(`${URL_API}guardrailtype`);
            let data = response["data"];
            context.commit("updateGuardrailTypesData", data);
        },
        async createGuardrailTypeData(context, name) {
            const config = {};
            const body = {
                name: name
            };
            await Vue.axios.post(`${URL_API}guardrailtype/store`, body, config);
            context.dispatch("getGuardrailTypesData");
        },
        async pushGuardrailTypeData(context, { id, name }) {
            const config = {};
            const body = {
                id: id,
                name: name
            };
            await Vue.axios.post(`${URL_API}guardrailtype/update`, body, config);
            context.dispatch("getGuardrailTypesData");
        },
        async destroyGuardrailTypeData(context, id) {
            const config = {};
            const body = {
                id: id
            };
            await Vue.axios.post(`${URL_API}guardrailtype/destroy`, body, config);
            context.dispatch("getGuardrailTypesData");
        }
    },
    mutations: {
        updateGuardrailTypesData(state, guardrailTypesData) {
            state.guardrailTypesData = guardrailTypesData;
        }
    },
    state: {
        guardrailTypesData: []
    },
    getters: {
        allGuardrailTypesData(state) {
            return state.guardrailTypesData;
        }
    }
};